module.exports = __webpack_public_path__ + "static/leaves-f2da954d17beee593c2c760f07593a5e.png";